// RaoCau — dải cảnh báo ĐỎ cho Admin khi cầu đồng bộ lỗi / không chạy (0358). Hiện trên mọi màn (trừ Cài đặt › Đồng bộ), ngay dưới thanh trên;
// vàng chỉ ở khối Tình trạng cầu của màn Đồng bộ.
import { useMemo } from "react";
import { useSucKhoeCau } from "../api/cauSucKhoe";
import { canhBaoCau } from "../core/canhBaoCau";
import { dieuHuong } from "./router";

export function RaoCau({ userId, dangODongBo }: { userId: string; dangODongBo: boolean }) {
  const q = useSucKhoeCau(userId, true);
  const ds = useMemo(() => (q.data ? canhBaoCau(q.data, q.dataUpdatedAt || Date.now()).filter((c) => c.muc === "do") : []), [q.data, q.dataUpdatedAt]);
  // Ở Cài đặt › Đồng bộ đã có khối "Tình trạng cầu" (đủ đỏ + vàng) ⇒ không lặp dải
  if (!ds.length || dangODongBo) return null;
  return (
    <div className="rao-cau" role="alert">
      <span className="rao-cau-icon" aria-hidden>⚠</span>
      <span className="rao-cau-chu" title={ds.map((c) => c.chu).join("\n")}>
        <b>Cầu đồng bộ:</b> {ds[0].chu}{ds.length > 1 ? ` (+${ds.length - 1} cảnh báo khác)` : ""}
      </span>
      <button type="button" className="btn sm" onClick={() => dieuHuong({ man: "caidat", con: ["dong-bo"] })}>Xem Đồng bộ</button>
    </div>
  );
}
